import { put, takeLatest, takeLeading } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import manageCoinApi from 'api/manageCoin';
import { apiErrorHandler } from 'utils';

import {
  GET_SETTING_COIN,
  UPDATE_SETTING_COIN,
  GET_HISTORY_COIN,
} from './actionTypes';
import {
  actionGetSettingCoinSuccess,
  actionGetSettingCoinFailed,
  actionUpdateSettingCoinSuccess,
  actionUpdateSettingCoinFailed,
  actionGetHistoryCoinSuccess,
  actionGetHistoryCoinFailed,
} from './actions';

function* getSettingCoin() {
  try {
    const response = yield manageCoinApi.getSettingCoin();

    yield put(actionGetSettingCoinSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetSettingCoinFailed());
  }
}

function* updateSettingCoin({ payload }) {
  const { data, callback } = payload || {};

  try {
    const response = yield manageCoinApi.updateSettingCoin(data);

    yield put(actionUpdateSettingCoinSuccess(response.payload));
    toast.success('Cập nhật chính sách xu thành công');

    if (callback) {
      callback(response.payload);
    }
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionUpdateSettingCoinFailed());
  }
}

function* getHistoryCoin({ payload }) {
  try {
    const response = yield manageCoinApi.getHistoryCoin(payload);

    yield put(actionGetHistoryCoinSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetHistoryCoinFailed());
  }
}

export default function* manageCoinSaga() {
  yield takeLeading(GET_SETTING_COIN, getSettingCoin);
  yield takeLeading(UPDATE_SETTING_COIN, updateSettingCoin);
  yield takeLatest(GET_HISTORY_COIN, getHistoryCoin);
}
